<div class="pb-2">
    <textarea kendoTextArea [placeholder]="to.placeholder" [class.k-state-invalid]="showError"
        [formControl]="formControl" [formlyAttributes]="field" [class]="to.className + ' k-textarea'">
</textarea>
    <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>